import React, { useState } from "react";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import { getVecidoCreditsAsync } from "../../../api/Dashboard";
import { useDatoPanel } from "../useDatoPanel";
import KpiPanel from "./KpiPanel";
import { porcentajeConDecimal } from "../panel";

// `activos`: total de créditos activos, para decir qué parte de ellos está vencida.
const VecidoCredits = ({ activos }) => {
  const [vencidoCredits, setVencidoCredits] = useState(0);
  const { cargando, error, recargar } = useDatoPanel(
    getVecidoCreditsAsync,
    (data) => setVencidoCredits(data.result)
  );

  return (
    <KpiPanel
      titulo="Créditos Vencidos"
      valor={vencidoCredits}
      formato="entero"
      icono={<MoneyOffIcon />}
      tono="error"
      detalle={
        !cargando && activos > 0
          ? `${porcentajeConDecimal(vencidoCredits, activos)} de los créditos activos`
          : undefined
      }
      cargando={cargando}
      error={error}
      onReintentar={recargar}
      destino="/credits"
      permiso="CREDITS VER"
      ayuda="Ver Créditos"
    />
  );
};

export default VecidoCredits;
